import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

const Group = ({ content }) => {
    const groupList = content?.results || [];

    return (
        <div className={styles.group}>
            {groupList.map((groupItem, grounpIndex) => {
                const countryList = groupItem?.ranking || [];

                return (
                    <div key={grounpIndex} className={styles.groupItem}>
                        <div className={styles.groupName}>{groupItem.group}</div>
                        <table className={styles.groupTable}>
                            <tbody>
                                {countryList.map((countryItem) => {
                                    return (
                                        <tr key={countryItem.id} className={styles.groupTr}>
                                            <td className={styles.flag}>
                                                <img className={styles.flagPic} src={countryItem.icon} />
                                            </td>
                                            <td className={styles.country}>{countryItem.country}</td>
                                            <td className={styles.score}>{countryItem.score}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                );
            })}
        </div>
    );
};

Group.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Group);
